import React, { createContext, useContext, useReducer } from 'react';

const StoreContext = createContext();

export const StoreProvider = ({ reducer, initialState, children }) => (
  <StoreContext.Provider value={useReducer(reducer, initialState)}>
    {children}
  </StoreContext.Provider>
)

export const useStateValue = () => useContext(StoreContext);